export default __webpack_public_path__ + "static/media/1.5be8f593.jpeg";